import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { assert } from 'src/app/utils/assert.util';
import { SKUMapEntry } from 'src/app/interfaces/sku-map-entry';
import { environment } from 'src/environments/environment';
import { SizedSKUMapEntry } from 'src/app/interfaces/sized-sku-map-entry';

@Injectable({
  providedIn: 'root'
})
export class SkuMapProviderService{
  private webProvider = inject(WebProviderService);
  private readonly baseURL = environment.apiURL;
  private get attributeURL() {
    return '/api/SKUMap';
  }

  async get(haloSKU: string): Promise<SKUMapEntry | null> {
    const skuMapEntry = await this.webProvider.get<SKUMapEntry>(`${this.baseURL}${this.attributeURL}?haloSKU=${haloSKU}`);
    return skuMapEntry;
  }

  async getReverse(ringBuilderSKU: string, size?: number): Promise<SKUMapEntry[]> {
    const url = new URL(`${this.baseURL}${this.attributeURL}/reverseLookup`);
    url.searchParams.set('ringBuilderSKU', ringBuilderSKU);
    if (size) {
      url.searchParams.set('fingerSize', size.toString());
    }
    const skuMapEntries = await this.webProvider.get<SKUMapEntry[]>(url.href);
    assert(skuMapEntries);
    return skuMapEntries;
  }

  async getWithShortCode(shortCode: number): Promise<SizedSKUMapEntry | null> {
    const skuMapEntry = await this.webProvider.get<SizedSKUMapEntry>(`${this.baseURL}${this.attributeURL}/shortCodeLookup?shortCode=${shortCode}`);
    return skuMapEntry;
  }
}

